// import ModalForm from "./Form";
import SiblingInformationTableForm from "./SiblingInformationTableForm";
import {
	SIBLING_INFORMATION,
	DATATABLE_EXPORT,
} from "../../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../../Config/ApiUrl";

export const Schema = {
	components: { SiblingInformationTableForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint:
				SIBLING_INFORMATION +
				"/" +
				this.value.clc_id_number +
				"/sibling",
			tableId: "sibling-information-table",
			formId: "sibling-information-table-form",
			rowData: {},
			tableColumns: [
				{
					title: "First Name",
					type: "text",
					key: "name",
				},
				{
					title: "Last Name",
					type: "text",
					key: "surname",
				},
				{
					title: "Date of Birth",
					type: "text",
					key: "date_of_birth",
				},
				{
					title: "School Name",
					type: "custom-html",
					key: "school",
					isVisible: true,
					modifier: (value) => {
						if (value && value.name) {
							return `<span>${this.$t(value.name)}</span>`;
						}
					},
				},
				{
					title: "School Level",
					type: "custom-html",
					key: "school_level",
					isVisible: true,
					modifier: (value) => {
						if (value && value.name) {
							return `<span>${this.$t(value.name)}</span>`;
						}
					},
				},
				{
					title: "Status",
					type: "custom-html",
					key: "status",
					isVisible: true,
					modifier: (value) => {
						if (value && value.status) {
							return `<span class="badge badge-sm badge-pill badge-${value.color_status ?? 'primary'}">${this.$t(
								value.status
							)}</span>`;
						}
					},
				},
				{
					title: "CLC ID Number",
					type: "text",
					key: "clc_id_number",
				},
			],
			actionObj: {},
			options: {
				name: "SiblingInformationTable",
				url:
					SIBLING_INFORMATION +
					"/" +
					this.value.clc_id_number +
					"/sibling",
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {},
};
